import { useEffect, useState } from 'react';
import { api } from '../../api/cliente';
import type { CapturaPublica } from '../../api/tipos';

/**
 * Preço e situação da captura automática, vindos do servidor.
 *
 * Mesma regra do `usePrecos`: nada de valor escrito à mão. E a situação
 * ("em liberação" ou "disponível") acompanha o `DFE_SOMENTE_ADMIN` do
 * servidor — liberar a função não exige mexer no front.
 *
 * `null` enquanto carrega, e para sempre se falhar: aí a página mostra só o
 * texto, que vale nos dois casos.
 */
export function useCapturaPublica(ativo = true): CapturaPublica | null {
  const [dados, setDados] = useState<CapturaPublica | null>(null);

  useEffect(() => {
    if (!ativo) return;
    let vivo = true;
    api<CapturaPublica>('/dfe/publico')
      .then((d) => vivo && setDados(d))
      .catch(() => undefined);
    return () => {
      vivo = false;
    };
  }, [ativo]);

  return dados;
}
